export const createDetailsDesc = (movie) => {
  return (
    `<p class="film-details__film-description">
      ${movie.description}
    </p>`
  );
};
